import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, SectionTitleEmbedded, Tag } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'persons/employment';


const AuthorizedsOfEmployment = (params) => {

    const { t } = useTranslation();

    const {existingModules} = useContext(AppContext);

    // DATA PROVIDER
    const { item, save, loadOne, loadAll, destroy, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const modelName = existingModules[dataProviderName].modelName
    const detailConfig = {
            "tabs": [
                {
                    "name": "vehicle_association",
                    "fieldsets": [
                        {
                            "name": "authorizeds",
                            "fields": {
                                "authorizeds": {
                                    "type": "relationship",
                                    "relation": {
                                        "drawerRoute": "persons",
                                        "inverseRelation": "employment",
                                        "inverseRelationType": "relationship",
                                        "limit": 1000
                                    },
                                    "view": "person"
                                }
                            }
                        }
                    ]
                }
            ],
            "validation": []
        }

    useEffect(() => {
        loadOne(params.filters?._id);
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = (data) => {
        save && save({ ...data, filters: params.filters });
    }

    return <>
        {
            item &&
            <>
                <SectionTitleEmbedded 
                    label={  t('Manage authorization to drive')  } 
                    className={'col-12'}
                    tag={<Tag label={item?.data?.role+'@'+item?.data?.legalEntity?.name} color="secondary"/>}
                />
                <DetailComponent
                    values={{ ...item?.data }}
                    modelName={modelName}
                    detailConfig={detailConfig}
                    dataProviderName={dataProviderName}
                    onEditing={setEditing}
                    save={handleSave}
                    saving={saving}
                    errors={errors}
                    errorMessage={errorMessage}
                    isEmbedded={true}
                    {...params}
                />
            </>
        }
    </>
}

export default AuthorizedsOfEmployment;


